import React from "react"
import styled from "styled-components"
import { Helmet } from "react-helmet"

import {
  BodyCopy,
  StandardContainer,
  StyledHeading,
  SectionWrapper,
} from "../../common"

const StyledContactForm = styled(StandardContainer)`
  text-align: center;
  padding: 0 2rem;
  margin: ${(props) => props.theme.spacers.med} auto;
  > form {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .form_item {
      width: 100%;
    }
    .form_actions,
    .captcha {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media ${(props) => props.theme.breakpoints.medium} {
    > form {
      flex-direction: row;
      .form_item {
        width: calc(50% - 1rem);
      }
      .form_item.full {
        width: 100%;
      }
    }
  }

  @media ${(props) => props.theme.breakpoints.large} {
    margin: ${(props) => props.theme.spacers.large} auto;
  }
`

export const HubspotForm = ({ heading, subheading, portal_id, form_id }) => {
  React.useEffect(() => {
    const initializeHubspotForm = () => {
      if ("hbspt" in window) {
        window.hbspt.forms.create({
          portalId: portal_id,
          formId: form_id,
          target: "#hubspot-form",
        })
      } else {
        setTimeout(initializeHubspotForm, 500)
      }
    }
    initializeHubspotForm()
  }, [form_id, portal_id])
  let isIE

  if (typeof document !== "undefined") {
    isIE = /*@cc_on!@*/ false || !!document.documentMode
  }

  return (
    <>
      <div id="hubspot">
        <SectionWrapper>
          <StyledContactForm $wrappednarrow>
            <BodyCopy>
              <StyledHeading size="h2">{heading?.text}</StyledHeading>
              <div
                dangerouslySetInnerHTML={{ __html: subheading?.html }}
                style={{ marginBottom: "2rem" }}
              />
            </BodyCopy>

            <div id="hubspot-form" />
          </StyledContactForm>
        </SectionWrapper>
      </div>

      <Helmet>
        {isIE ? (
          <script
            charset="utf-8"
            type="text/javascript"
            src="//js.hsforms.net/forms/v2-legacy.js"
          ></script>
        ) : (
          <script
            charset="utf-8"
            type="text/javascript"
            src="//js.hsforms.net/forms/shell.js"
          ></script>
        )}
      </Helmet>
    </>
  )
}
